import Cookies from 'js-cookie';

const urlLang = window.location.pathname.split('/')[1];

if (urlLang) {
    const currentLangCookie = Cookies.get('client_selected_language');
    if (currentLangCookie !== urlLang) {
        Cookies.set('client_selected_language', urlLang, { expires: 365 / 2, path: '/' });
    }
}
